<template>
  <v-app id="billing-settings">
      <div class="wrap-billing-settings">
        <v-layout class="wrap xs12">
          <v-layout>
            <v-flex class="mb-4">
              <div class="billing-top-header">
                <div class="caption mb-2">
                  <span 
                    @click="$router.push('/settings')"
                    class="pointer primary--text text-uppercase"
                  >Settings</span>
                  <span class="px-2 grey--text">/</span>
                  <span 
                    class="grey--text text-uppercase"
                  >Branding</span>
                </div>
                <h2 class="headline">Branding</h2>        
              </div>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
        </v-layout>
      </div>

      <v-card class="mt-6 py-6">
        <v-layout class="wrap px-6 mb-4">
          <v-flex>
            <div class="title">Company Info</div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-layout class="wrap justify-end">
            <v-btn 
              @click="editBrandingModal(false, 'company_info')"
              sx12
              class="mr-0 mt-0"
              style="max-width: 130px;"
              color="primary"
              :disabled="loading"
            >
              Edit
            </v-btn>
          </v-layout>
        </v-layout>
        <v-progress-linear :indeterminate="loading" class="ma-0" :class="{ 'no-opacity': !loading }" style="height: 2px;"></v-progress-linear>
        <v-layout class="wrap px-6 pt-3">
          <v-flex class="xs12">
            <div>
              <div class="text-uppercase">Business Name</div>
              <div class="title mb-4">{{ user.organization_name }}</div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="wrap px-6">
          <v-flex class="xs12">
            <div class="mb-4">
              <div class="mb-2 text-uppercase">Business Address</div>
              <template 
                v-if="
                  !no_data.includes(user.organization_address_1) && 
                  !no_data.includes(user.organization_city) &&
                  !no_data.includes(user.organization_state) &&
                  !no_data.includes(user.organization_zip) &&
                  !no_data.includes(user.organization_country)
                ">
                <div class="text-body-2">{{ user.organization_address_1 }}</div>
                <div class="text-body-2">{{ `${user.organization_city}, ${user.organization_state}, ${user.organization_zip}` }}</div>
                <div class="text-body-2">{{ user.organization_country }}</div>
              </template>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="wrap px-6 pt-2">
          <v-flex class="xs12">
            <div class="mb-4">
              <div class="mb-2 text-uppercase">Business Email</div>
              <template 
                v-if="
                  !no_data.includes(user.organization_primary_email)
                ">
                <div class="text-body-2">{{ user.organization_primary_email }}</div>
              </template>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="wrap px-6 pt-2">
          <v-flex class="xs12">
            <div class="mb-4">
              <div class="mb-2 text-uppercase">Business Phone</div>
              <template 
                v-if="
                  !no_data.includes(user.organization_primary_phone)
                ">
                <div class="text-body-2">{{ displayPhone(user.organization_primary_phone) }}</div>
              </template>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="wrap px-6 pt-2 mb-2">
          <v-flex class="xs12">
            <div>
              <div class="mb-2 text-uppercase">Website</div>
              <v-layout v-if="organization_settings.website">
                <a target="_blank" class="body-2" :href="organization_settings.website">{{ organization_settings.website }}</a>
              </v-layout>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="mt-6 py-6">
        <v-layout class="wrap px-6 mb-4">
          <v-flex>
            <div class="title">Branding</div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-layout class="wrap justify-end">
            <v-btn 
              @click="editBrandingModal(false, 'branding')"
              sx12
              class="mr-0 mt-0"
              style="max-width: 130px;"
              color="primary"
              :disabled="loading"
            >
              Edit
            </v-btn>
          </v-layout>
        </v-layout>
        <v-layout class="wrap px-6 pt-2">
          <v-flex class="xs12 mb-6">
            <div>
              <div class="mb-2 text-uppercase">Logo on Client Onboarding Form</div>
              <div v-if="!no_data.includes(organization_settings.logo)">
                <img :src="organization_settings.logo" alt="Organisation logo" style="max-width: 100%; max-height: 100px;" />
                <!-- <div
                  @click="removeLogoModal('onboarding')"
                  class="body-2 primary--text"
                  style="cursor: pointer; text-decoration: underline;"
                  >Remove Logo</div> -->
              </div>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
          <v-flex class="xs12 mb-6">
            <div>
              <div class="mb-2 text-uppercase">Logo on Client Portal</div>
              <div v-if="!no_data.includes(organization_settings.client_portal_logo)">
                <img :src="organization_settings.client_portal_logo" alt="Organisation Logo on Client Portal" style="max-width: 100%; max-height: 100px;" />
                <!-- <div
                  @click="removeLogoModal('header')"
                  class="body-2 primary--text"
                  style="cursor: pointer; text-decoration: underline;"
                  >Remove Logo</div> -->
              </div>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
          <v-flex class="xs12">
            <div class="mb-4">
              <div class="mb-2 text-uppercase">Branding Color on Client Onboarding Form</div>
              <v-layout v-if="organization_settings.branding_color">
                <div class="mr-2" style="display: inline-block; width: 21px; height: 21px; vertical-align: middle;" :style="{ background: organization_settings.branding_color, border: calculateColorContrast(organization_settings.branding_color) <= 3 ? 'solid 1px #00000039' : ''}"></div>
                <strong>{{ organization_settings.branding_color }}</strong>
              </v-layout>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
          <v-flex class="xs12">
            <div class="mb-4">
              <div class="mb-2 text-uppercase">Branding Color on Client Portal</div>
              <v-layout v-if="organization_settings.primary_color">
                <div class="mr-2" style="display: inline-block; width: 21px; height: 21px; vertical-align: middle;" :style="{ background: organization_settings.primary_color, border: calculateColorContrast(organization_settings.primary_color) <= 3 ? 'solid 1px #00000039' : ''}"></div>
                <strong>{{ organization_settings.primary_color }}</strong>
              </v-layout>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
          <v-flex class="xs12">
            <div class="mb-4">
              <div class="mb-2 text-uppercase">Header Background Color</div>
              <v-layout v-if="organization_settings.header_color">
                <div class="mr-2" style="display: inline-block; width: 21px; height: 21px; vertical-align: middle;" :style="{ background: organization_settings.header_color, border: calculateColorContrast(organization_settings.header_color) <= 3 ? 'solid 1px #00000039' : ''}"></div>
                <strong>{{ organization_settings.header_color }}</strong>
              </v-layout>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card v-if="['Professional', 'POOfessional'].includes(subscriptionPackage) || isTrialActive" class="mt-6 py-6">
        <v-layout class="wrap px-6 mb-4">
          <v-flex>
            <div class="title">Google Analytics</div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-layout class="wrap justify-end">
            <v-btn 
              @click="editBrandingModal(false, 'google_analytics')"
              sx12
              class="mr-0 mt-0"
              style="max-width: 130px;"
              color="primary"
              :disabled="loading"
            >
              Edit
            </v-btn>
          </v-layout>
        </v-layout>
        <v-layout class="wrap px-6 pt-2">
          <v-flex class="xs12">
            <div class="mb-2">
              <div class="mb-2 text-uppercase">Google Analytics (GA4) Measurement ID</div>
              <template 
                v-if="
                  !no_data.includes(organization_settings.ga_tracking_id)
                ">
                <div class="text-body-2">{{ organization_settings.ga_tracking_id }}</div>
              </template>
              <em v-else class="grey--text">No data</em>
            </div>
          </v-flex>
        </v-layout>
      </v-card>

      <v-dialog v-if="editBrandingDialog" v-model="editBrandingDialog" max-width="500px" persistent>
        <v-card class="pa-4">
          <v-card-title class="px-4">
              <h2 v-if="editType === 'company_info'" class="title">Edit Company Info</h2>
              <h2 v-if="editType === 'branding'" class="title">Edit Branding</h2>
              <h2 v-if="editType === 'google_analytics'" class="title">Edit Google Analytics</h2>
              <h2 v-if="editType === 'all'" class="title">Edit Branding</h2>
          </v-card-title>
          <div v-if="brandingModalLoading" class="my-4 px-4">
            <v-progress-linear
              :indeterminate="brandingModalLoading"
              :class="{ 'no-opacity': !brandingModalLoading }"
              style="height: 2px;"
            ></v-progress-linear>
          </div>
          <template v-if="!brandingModalLoading">
            <div class="py-4 px-6">
              <v-flex v-if="['all', 'company_info'].includes(editType)" xs12>
                <v-text-field
                  label="Business Name"
                  v-model="editOrganizationContactData.name"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editOrganizationContactData.name) ||
                    server_errors.name
                  "
                  @blur="$v.editOrganizationContactData.name.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="['all', 'company_info'].includes(editType)" xs12>
                <v-text-field
                  label="Address"
                  v-model="editOrganizationContactData.physical_address_1"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editOrganizationContactData.physical_address_1) ||
                    server_errors.physical_address_1
                  "
                  @blur="$v.editOrganizationContactData.physical_address_1.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="['all', 'company_info'].includes(editType)" xs12>
                <v-text-field
                  label="City"
                  v-model="editOrganizationContactData.physical_city"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editOrganizationContactData.physical_city) ||
                    server_errors.physical_city
                  "
                  @blur="$v.editOrganizationContactData.physical_city.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-container v-if="['all', 'company_info'].includes(editType)" class="grid-list-md px-0 pt-0">
                <v-layout class="wrap">
                  <v-flex class="sm8 xs12">
                    <v-autocomplete
                      :items="states"
                      label="State"
                      item-text="full_name"
                      item-value="name"
                      v-model="editOrganizationContactData.physical_state"
                      placeholder="Please Select"
                      :error-messages="
                        errors($v.editOrganizationContactData.physical_state) ||
                          server_errors.physical_state
                      "
                      @blur="$v.editOrganizationContactData.physical_state.$touch()"
                      @focus="resetServerValidation"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="sm4 xs12">
                    <v-text-field
                      label="ZIP Code"
                      v-model="editOrganizationContactData.physical_zip"
                      placeholder="Please Enter"
                      v-mask="'#####'"
                      :error-messages="
                        errors($v.editOrganizationContactData.physical_zip) || server_errors.physical_zip
                      "
                      @blur="$v.editOrganizationContactData.physical_zip.$touch()"
                      @focus="resetServerValidation"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-flex v-if="['all', 'company_info'].includes(editType)" class="xs12">
                <v-text-field
                  label="Email"
                  v-model.trim="editOrganizationContactData.primary_email"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editOrganizationContactData.primary_email) || server_errors.primary_email
                  "
                  @blur="$v.editOrganizationContactData.primary_email.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="['all', 'company_info'].includes(editType)" class="xs12">
                <v-text-field
                  label="Phone"
                  v-model="editOrganizationContactData.primary_phone"
                  placeholder="Please Enter"
                  v-mask="'(###) ### - ####'"
                  :error-messages="
                    errors($v.editOrganizationContactData.primary_phone) ||
                      server_errors.primary_phone
                  "
                  @blur="$v.editOrganizationContactData.primary_phone.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="['all', 'company_info'].includes(editType)" class="xs12">
                <v-text-field
                  label="Contact"
                  v-model="editOrganizationContactData.primary_contact"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.editOrganizationContactData.primary_contact) ||
                      server_errors.primary_contact
                  "
                  @blur="$v.editOrganizationContactData.primary_contact.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" class="xs12">
                <v-switch
                  v-model="editBrandingData.show_name_onboarding"
                  label="Show Organization Name on Onboarding Form"
                ></v-switch>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" class="xs12 mb-4">
                  <div class="text-subtitle-2">Logo on Client Onboarding Form</div>
                  <img v-if="logo_preview" :src="logo_preview" alt="Logo preview" class="mt-2" style="max-width: 100%; max-height: 100px;">
                  <img v-else-if="organization_settings.logo" :src="organization_settings.logo" alt="Curent logo" class="mt-2" style="max-width: 100%; max-height: 100px;">
                  <div v-else class="my-2">
                    <em class="grey--text text-body-2">No data</em>
                  </div>
                  <div>
                    <v-btn text class="ml-n1 px-1 mr-2 text-capitalize" color="primary" @click="$refs.inputUpload.click()">
                      {{ no_data.includes(logo_preview) && (no_data.includes(organization_settings) || no_data.includes(organization_settings.logo)) ? 'Upload Logo' : 'Replace' }}
                    </v-btn>
                    <v-btn
                      v-if="
                        no_data.includes(logo_preview) &&
                        !no_data.includes(organization_settings) &&
                        !no_data.includes(organization_settings.logo)
                      "
                      text
                      class="ml-n1 px-1 mr-2 text-capitalize"
                      color="error"
                      :disabled="removeLogoLoading"
                      :loading="removeLogoLoading"
                      @click="removeLogoModal('onboarding', true)"
                    >
                      Remove
                    </v-btn>
                    <span v-if="logo_preview" class="grey--text body-2">{{ image_name }}             
                        <v-btn v-if="imageSelected" class="ml-0" color="grey" fab small text @click="onFileRemoved">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </span>
                    <input v-show="false" type="file" ref="inputUpload" @change="onFileChanged" accept="image/jpg, image/jpeg, image/png"><br>
                  </div>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" class="xs12">
                <v-switch
                  v-model="editBrandingData.show_logo_onboarding"
                  label="Show Logo on Onboarding Form"
                ></v-switch>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" class="xs12 mb-4">
                <div class="text-subtitle-2">Logo on Client Portal</div>
                <div class="text-caption mt-2">We recommend to use transparent and horizontal version of the logo since it shows on the header bar at top of the screen which is 64px height.</div>
                <img v-if="header_logo_preview" :src="header_logo_preview" alt="Header logo preview" class="mt-2" style="max-width: 100%; max-height: 100px;">
                <img v-else-if="organization_settings.client_portal_logo" :src="organization_settings.client_portal_logo" alt="Curent header logo" class="mt-2" style="max-width: 100%; max-height: 100px;">
                <div v-else class="my-2">
                    <em class="grey--text text-body-2">No data</em>
                  </div>
                <div>
                  <v-btn text class="ml-n1 px-1 mr-2 text-capitalize" color="primary" @click="$refs.headerLogoInputUpload.click()">
                    {{ no_data.includes(header_logo_preview) && (no_data.includes(organization_settings) || no_data.includes(organization_settings.client_portal_logo)) ? 'Upload Logo' : 'Replace' }}
                  </v-btn>
                  <v-btn
                      v-if="
                        no_data.includes(header_logo_preview) &&
                        !no_data.includes(organization_settings) &&
                        !no_data.includes(organization_settings.client_portal_logo)
                      "
                      text
                      class="ml-n1 px-1 mr-2 text-capitalize"
                      color="error"
                      :disabled="removeLogoLoading"
                      :loading="removeLogoLoading"
                      @click="removeLogoModal('header', true)"
                    >
                      Remove
                    </v-btn>
                  <span v-if="header_logo_preview" class="grey--text body-2">{{ header_image_name }}             
                      <v-btn v-if="headerImageSelected" class="ml-0" color="grey" fab small text @click="onHeaderFileRemoved">
                          <v-icon>close</v-icon>
                      </v-btn>
                  </span>
                  <input v-show="false" type="file" ref="headerLogoInputUpload" @change="onHeaderFileChanged" accept="image/jpg, image/jpeg, image/png"><br>
                </div>
              </v-flex>
              <v-flex v-if="['all', 'company_info'].includes(editType)" xs12>
                <v-text-field
                  label="Website"
                  class="mb-4"
                  v-model="editBrandingData.website"
                  placeholder="Please Enter"
                  persistent-hint
                  hint="Onboarding Form Logo will be linked to this website"
                  :error-messages="errors($v.editBrandingData.website)"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" xs12>
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="225px"
                  min-width="225px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="editBrandingData.branding_color"
                      label="Branding Color on Client Onboarding Form"
                      readonly
                      placeholder="Please Select"
                      :error-messages="
                        errors($v.editBrandingData.branding_color) ||
                          server_errors.branding_color
                      "
                      @focus="startingEditColor = editBrandingData.branding_color"
                    >
                      <template slot="prepend">
                        <v-icon :color="editBrandingData.branding_color || '#FFFFFF'" :style="no_data.includes(editBrandingData.branding_color) || calculateColorContrast(editBrandingData.branding_color) <= 3 ? 'text-shadow: 0 0 2px black' : ''">brightness_1</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <chrome-picker class="elevation-0" v-model="editBrandingData.branding_color" @input="updateColorValue" :disableAlpha="true"></chrome-picker>
                  <div
                    class="caption white px-4 mt-n2 mb-n1"
                    :class="errors($v.editBrandingData.branding_color) ? 'error--text' : 'transparent--text'"
                  >{{ errors($v.editBrandingData.branding_color) || 'placeholder' }}</div>
                  <v-card-actions class="white">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="cancelUpdateColor">Cancel</v-btn>
                      <v-btn color="primary" @click="confirmUpdateColor">Ok</v-btn>
                  </v-card-actions>              
                </v-menu>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" xs12>
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="225px"
                  min-width="225px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="editBrandingData.primary_color"
                      label="Branding Color on Client Portal"
                      readonly
                      placeholder="Please Select"
                      :error-messages="
                        errors($v.editBrandingData.primary_color) ||
                          server_errors.primary_color
                      "
                      @focus="startingEditPrimaryColor = editBrandingData.primary_color"
                    >
                      <template slot="prepend">
                        <v-icon :color="editBrandingData.primary_color || '#FFFFFF'" :style="no_data.includes(editBrandingData.primary_color) || calculateColorContrast(editBrandingData.primary_color) <= 3 ? 'text-shadow: 0 0 2px black' : ''">brightness_1</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <chrome-picker class="elevation-0" v-model="editBrandingData.primary_color" @input="updatePrimaryColorValue" :disableAlpha="true"></chrome-picker>
                  <div
                    class="caption white px-4 mt-n2 mb-n1"
                    :class="errors($v.editBrandingData.primary_color) ? 'error--text' : 'transparent--text'"
                  >{{ errors($v.editBrandingData.primary_color) || 'placeholder' }}</div>
                  <v-card-actions class="white">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="cancelUpdatePrimaryColor">Cancel</v-btn>
                      <v-btn color="primary" @click="confirmUpdatePrimaryColor">Ok</v-btn>
                  </v-card-actions>              
                </v-menu>
              </v-flex>
              <v-flex v-if="['all', 'branding'].includes(editType)" xs12>
                <v-menu
                  ref="menu3"
                  :close-on-content-click="false"
                  v-model="menu3"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="225px"
                  min-width="225px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="editBrandingData.header_color"
                      label="Header Background Color"
                      readonly
                      placeholder="Please Select"
                      hint="Header background color shows at the very top of the client portal and is the bar where the name and/or logo of the company is shown."
                      persistent-hint
                      @focus="startingEditHeaderColor = editBrandingData.header_color"
                    >
                      <template slot="prepend">
                        <v-icon :color="editBrandingData.header_color || '#FFFFFF'" :style="no_data.includes(editBrandingData.header_color) || calculateColorContrast(editBrandingData.header_color) <= 3 ? 'text-shadow: 0 0 2px black' : ''">brightness_1</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <chrome-picker class="elevation-0" v-model="editBrandingData.header_color" @input="updateHeaderColorValue" :disableAlpha="true"></chrome-picker>
                  <v-card-actions class="white">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="cancelUpdateHeaderColor">Cancel</v-btn>
                      <v-btn color="primary" @click="menu3 = false">Ok</v-btn>
                  </v-card-actions>              
                </v-menu>
              </v-flex>
              <v-flex v-if="['all', 'google_analytics'].includes(editType) && (['Professional', 'POOfessional'].includes(subscriptionPackage) || isTrialActive)" class="xs12">
                <v-text-field
                  label="Google Analytics (GA4) Measurement ID"
                  v-model="editBrandingData.ga_tracking_id"
                  placeholder="Please Enter"
                  persistent-hint
                  hint="Will be used for new client onboarding"
                  :error-messages="
                    errors($v.editBrandingData.ga_tracking_id) ||
                      server_errors.ga_tracking_id
                  "
                  @blur="$v.editBrandingData.ga_tracking_id.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-alert class="pa-2 mt-4" :value="$v.editBrandingData.$error || $v.editOrganizationContactData.$error" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">Please fill out form correctly</span>
              </v-alert>
              <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeEditBranding">Cancel</v-btn>
                <v-btn color="primary" :loading="editBrandingLoading" :disabled="editBrandingLoading || removeLogoLoading" @click="editBranding">Save</v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-dialog>

      <!-- Remove Logo Dialog -->
      <v-dialog v-model="removeLogoDialog" max-width="500px" persistent>
          <v-card class="pa-4">
              <v-card-title class="px-2">
                  <h2 v-if="removeLogoType === 'onboarding'" class="title">Remove Logo</h2>
                  <h2 v-else class="title">Remove Header Logo</h2>
              </v-card-title>

              <div class="pa-4">
                  <div class="dialog-warning-note">
                    <v-layout class="align-center fill-height">
                      <v-icon left color="error" class="mr-2">error</v-icon>
                      <span v-if="removeLogoType === 'onboarding'" class="d-flex">Are you sure you want to remove logo?</span>
                      <span v-else class="d-flex">Are you sure you want to remove header logo?</span>
                    </v-layout>
                  </div>
                  <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
                      <span class="caption">{{ serverValidationMessage }}</span>
                  </v-alert>
              </div>
              <v-card-actions class="px-4">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeRemoveLogo">Cancel</v-btn>
                  <v-btn color="primary" :loading="removeLogoLoading" :disabled="removeLogoLoading" @click="removeLogo">Remove</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapGetters, mapActions } from "vuex"
import { validationMixin } from 'vuelidate'
import { required, helpers, url, email } from 'vuelidate/lib/validators'
import { valMessages, getValMessage } from '@/common/error-messages'
import { Chrome } from 'vue-color'
import { mask } from 'vue-the-mask'

const getColorContrast = (color1 = '#ffffff') => {
  let color2 = '#ffffff'

  const formatColor = hexcolor => {
    let hc = hexcolor

    if (hc.slice(0, 1) === '#') {
      hc = hc.slice(1);
    }

    if (hc.length === 3) {
      hc = hc.split('').map(function (hex) {
        return hex + hex;
        }).join('');
    }

    var r = parseInt(hc.substr(0,2),16);
    var g = parseInt(hc.substr(2,2),16);
    var b = parseInt(hc.substr(4,2),16);

    return [r, g, b]
  }

  let c1 = formatColor(color1)
  let c2 = formatColor(color2)

  const RED = 0.2126;
  const GREEN = 0.7152;
  const BLUE = 0.0722;

  const GAMMA = 2.4;

  const luminance = (r, g, b) => {
    var a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928
        ? v / 12.92
        : Math.pow((v + 0.055) / 1.055, GAMMA);
    });
    return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
  }

  const contrast = (rgb1, rgb2) => {
    var lum1 = luminance(...rgb1);
    var lum2 = luminance(...rgb2);
    var brightest = Math.max(lum1, lum2);
    var darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
  }
  return contrast(c1, c2) >= 3
}

let validations = {}

export default {
  name: "BrandingSettings",
  mixins: [validationMixin],
  directives: {mask},
  validations() {
    validations = {
      editBrandingData: {},
      editOrganizationContactData: {
      }
    }
    if (['all', 'company_info'].includes(this.editType)) {
      validations.editOrganizationContactData.name = { required }
      validations.editOrganizationContactData.physical_address_1 = { 
        required, 
        noCommas: v => !helpers.req(v) || !v.includes(','),
        noAmpersandCharacters: v => !helpers.req(v) || !v.includes('&')
        // noSpecialCharacters: v => !helpers.req(v) || !/[^-_A-Za-z0-9 #]+/g.test(v)
      }
      validations.editOrganizationContactData.physical_city = {
        required,
        noCommas: v => !helpers.req(v) || !v.includes(','),
        noAmpersandCharacters: v => !helpers.req(v) || !v.includes('&')
        // noSpecialCharacters: v => !helpers.req(v) || !/[^-_A-Za-z0-9 #]+/g.test(v)
      },
      validations.editOrganizationContactData.physical_state = { required }
      validations.editOrganizationContactData.physical_zip = {
        required,
        zipCode: v => !helpers.req(v) || /^\d{5}$/.test(v)
      }
      validations.editOrganizationContactData.primary_email = { required, email }
      validations.editOrganizationContactData.primary_phone = { phone: v => !helpers.req(v) || /^\d{10}$/.test(v.replace(/[()-\s]/g, "")) }
      validations.editOrganizationContactData.primary_contact = { required }
      validations.editBrandingData.website = { url }
    }
    if (['all', 'branding'].includes(this.editType)) {
      validations.editBrandingData.branding_color = {
        // colorTooLight: v => !helpers.req(v) || getColorContrast(v)
      }
      validations.editBrandingData.primary_color = {
        colorTooLight: v => !helpers.req(v) || getColorContrast(v)
      }
    }
    if (['all', 'google_analytics'].includes(this.editType) && (['Professional', 'POOfessional'].includes(this.subscriptionPackage) || this.isTrialActive)) {
      validations.editBrandingData.ga_tracking_id = {
        // gaTrackingIdFormat: v => !helpers.req(v) || /(UA|YT|MO)-\d+-\d+/i.test(v)
      }
    }
    this.errors = getValMessage(valMessages)(validations)
    return validations
  },
  components: {
    'chrome-picker': Chrome
  },
  data() {
    return {
      no_data: [null, '', undefined, 'null'],
      loading: false,
      menu1: false,
      menu2: false,
      menu3: false,
      startingEditColor: '',
      startingEditPrimaryColor: '',
      startingEditHeaderColor: '',
      organization_settings: {},
      logo_preview: null,
      header_logo_preview: null,
      editBrandingDialog: false,
      brandingModalLoading: false,
      editBrandingLoading: false,
      editBrandingData: { branding_color: '', primary_color: '', header_color: '' },
      editOrganizationContactData: {},
      image_name: 'No file chosen',
      header_image_name: 'No file chosen',
      imageSelected: false,
      headerImageSelected: false,
      editType: 'all',

      removeLogoDialog: false,
      removeLogoLoading: false,
      removeLogoType: 'onboarding',

      serverValidation: true,
      serverValidationMessage: 'Oops something went wrong...',
      server_errors: {}
    }
  },
  mounted() {
    if(Boolean(this.$route.query.edit)) {
      this.editBrandingModal(true, 'all')
      let query = {...this.$route.query}
      delete query.edit
      this.$router.replace({ query })
    } else {
      this.initialize()
    }
  },
  methods: {
    ...mapActions(["checkAuth", 'vEmit']),
    initialize () {
      this.loading = true
      return new Promise((resolve, reject) => {
        Promise.all([this.getOrganizationSettings(), this.getOrganizationContact()])
          .then(() => {
            this.loading = false
            resolve()
          })
          .catch(() => {
            this.loading = false
            reject()
          })
      })
    },
    getOrganizationSettings () {
      return new Promise((resolve, reject) => {
        ApiService.get('/organization_settings')
          .then(response => {
            let organization_settings = {}
            response.data.organization_settings.forEach(i => {
              organization_settings[i.key] = i.value !== 'null' ? i.value : ''
            })
            organization_settings.show_logo_onboarding = Boolean(Number(organization_settings.show_logo_onboarding))
            organization_settings.show_name_onboarding = Boolean(Number(organization_settings.show_name_onboarding))
            organization_settings.show_payroll_filed_tech = Boolean(Number(organization_settings.show_payroll_filed_tech))
            this.organization_settings = organization_settings
            resolve()
          })
          .catch(error => {
            console.log(error)
            reject()
          })
      })
    },
    getOrganizationContact() {
      return new Promise((resolve, reject) => {
        this.checkAuth()
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getStates () {
      return new Promise((resolve, reject) => {
        ApiService.get('/states')
          .then(response => {
            this.states = response.data.states
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    editBrandingModal (initialize = false, type = 'all') {
      this.resetServerValidation()
      this.$v.editBrandingData.$reset()
      this.$v.editOrganizationContactData.$reset()
      this.editType = type
      this.menu1 = false
      this.menu2 = false
      this.menu3 = false
      this.editBrandingDialog = true
      this.brandingModalLoading = true
      let requests = [this.getStates()]
      if(initialize) { requests = [...requests, this.initialize()] }
      Promise.all(requests)
        .then(() => {
          this.editBrandingData = {branding_color: '', primary_color: '', header_color: '', ...this.organization_settings}
          this.editOrganizationContactData = {
            name: this.user.organization_name,
            physical_address_1: this.user.organization_address_1,
            physical_city: this.user.organization_city,
            physical_state: this.user.organization_state,
            physical_zip: this.user.organization_zip,
            primary_email: this.user.organization_primary_email,
            primary_phone: this.user.organization_primary_phone,
            primary_contact: this.user.organization_primary_contact
          }
          delete this.editBrandingData.logo
          delete this.editBrandingData.client_portal_logo
          this.resetServerValidation()
          this.onFileRemoved()
          this.editBrandingLoading = false
          this.brandingModalLoading = false
        })
        .catch(error => {
          this.closeEditBranding()
          this.brandingModalLoading = false
        })
    },
    editBranding () {
      this.resetServerValidation()
      this.$v.editBrandingData.$touch()
      this.$v.editOrganizationContactData.$touch()

      if (!this.$v.editBrandingData.$invalid && !this.$v.editOrganizationContactData.$invalid) {
        this.editBrandingLoading = true
        this.resetServerValidation()
        Promise.all([this.editOrganizationSettings(), this.editOrganizationContact()])
          .then(valuse => {
            this.editBrandingLoading = false
            let successMessage = 'Branding has been successfully edited.'
            if (this.editType === 'company_info') {
              successMessage = 'Company Info has been successfully edited.'
            }
            if (this.editType === 'google_analytics') {
              successMessage = 'Google Analytics has been successfully edited.'
            }
            this.vEmit({ 
              name: "notification",
              data: {
                status: 'success',
                text: successMessage
              }
            });
            this.closeEditBranding()
            this.initialize()
          })
          .catch(() => this.editBrandingLoading = false)
      }
    },
    editOrganizationSettings() {
      return new Promise((resolve, reject) => {
        let body = { organization_settings: []}
        for (let [key, value] of Object.entries(this.editBrandingData)) {
          if(!this.no_data.includes(value) && (typeof value !== 'string' || value.trim() !== '')) {
            body.organization_settings.push({key: key, value: value})
          }
          if(typeof value === 'string' && value.trim() === '') {
            body.organization_settings.push({key: key, value: 'null'})
          }
        }
        ApiService.put('/organization_settings', body)
          .then(response => {
            resolve(response.data)
          })
          .catch(({ response }) => {
            this.serverValidation = false
            if(response.data.error){
              this.serverValidationMessage = this.titleCase(response.data.error)
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors
            }
            reject()
          })
      })
    },
    editOrganizationContact() {
      return new Promise((resolve, reject) => {
        let body = {...this.editOrganizationContactData}
        if(!this.no_data.includes(body.primary_phone)) {
          body.primary_phone = this.phoneWithoutMask(body.primary_phone)
        }
        ApiService.put('/organization_contact', body)
          .then(response => {
            resolve(response.data)
          })
          .catch(({ response }) => {
            this.serverValidation = false
            if(response.data.error){
              this.serverValidationMessage = this.titleCase(response.data.error)
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors
            }
            reject()
          })
      })
    },
    closeEditBranding () {
      this.editBrandingDialog = false
    },

    removeLogoModal (type = 'onboarding', remove_without_popup = false) {
      this.removeLogoType = type
      if (remove_without_popup) {
        this.removeLogo(false)
      } else {
        this.removeLogoDialog = true
      }
    },
    removeLogo (show_notification = true) {
        this.removeLogoLoading = true
        const url = this.removeLogoType === 'onboarding' ? '/organization_remove_logo' : 'organization_remove_client_portal_logo'
        ApiService.put(url)
            .then(response => {
                this.removeLogoLoading = false
                if (show_notification) {
                  this.vEmit({ 
                    name: "notification", 
                    data: {
                      status: 'success',
                      text: 'Logo has been successfully removed.'
                    }
                  });
                }
                this.closeRemoveLogo()
                this.initialize()
            })
            .catch(({ response }) => {
                this.removeLogoLoading = false
                this.serverValidation = false
                if(response.error){
                    this.serverValidationMessage = this.titleCase(response.error)
                }
            })
    },
    closeRemoveLogo() {
        this.removeLogoDialog = false
    },

    onFileChanged (event) {
      let image = event.target.files[0]
      this.image_name = image.name
      this.imageSelected = true
      this.logo_preview = URL.createObjectURL(image)

      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
          this.editBrandingData.logo = e.target.result
      }
    },
    onFileRemoved () {
      this.editBrandingData.logo = null
      this.imageSelected = false
      this.image_name = 'No file chosen'
      this.logo_preview = null
    },

    onHeaderFileChanged (event) {
      let image = event.target.files[0]
      this.header_image_name = image.name
      this.headerImageSelected = true
      this.header_logo_preview = URL.createObjectURL(image)

      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
          this.editBrandingData.client_portal_logo = e.target.result
      }
    },
    onHeaderFileRemoved () {
      this.editBrandingData.client_portal_logo = null
      this.headerImageSelected = false
      this.header_image_name = 'No file chosen'
      this.header_logo_preview = null
    },
    phoneWithoutMask (phone) {
      if(phone && typeof phone === 'string') {
          return phone.replace(/[()-\s]/g, "")
      } else {
          return phone
      }
    },
    displayPhone (phone) {
      if(/^\d{10}$/.test(phone)) {
          return `(${phone.substr(0, 3)}) ${phone.substr(3, 3)} - ${phone.substr(6, 4)}`
      } else {
          return phone
      }
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '));
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = 'Oops something went wrong...'
      this.server_errors = {}
    },
    errors: getValMessage(valMessages)(validations),
    updateColorValue(input) {
      this.editBrandingData.branding_color = input.hex
      this.$v.editBrandingData.branding_color.$touch()
    },
    confirmUpdateColor () {
      if (!this.$v.editBrandingData.branding_color.$invalid) {
        this.menu1 = false
      }
    },
    updatePrimaryColorValue(input) {
      this.editBrandingData.primary_color = input.hex
      this.$v.editBrandingData.primary_color.$touch()
    },
    confirmUpdatePrimaryColor () {
      if (!this.$v.editBrandingData.primary_color.$invalid) {
        this.menu2 = false
      }
    },
    updateHeaderColorValue(input) {
      this.editBrandingData.header_color = input.hex
    },
    cancelUpdateColor() {
      this.editBrandingData.branding_color = this.startingEditColor
      this.menu1 = false
    },
    cancelUpdatePrimaryColor() {
      this.editBrandingData.primary_color = this.startingEditPrimaryColor
      this.menu2 = false
    },
    cancelUpdateHeaderColor() {
      this.editBrandingData.header_color = this.startingEditHeaderColor
      this.menu3 = false
    },
    calculateColorContrast (color1 = '#ffffff') {
      let color2 = '#ffffff'

      const formatColor = hexcolor => {
        let hc = hexcolor

        if (hc.slice(0, 1) === '#') {
          hc = hc.slice(1);
        }

        if (hc.length === 3) {
          hc = hc.split('').map(function (hex) {
            return hex + hex;
            }).join('');
        }

        var r = parseInt(hc.substr(0,2),16);
        var g = parseInt(hc.substr(2,2),16);
        var b = parseInt(hc.substr(4,2),16);

        return [r, g, b]
      }

      let c1 = formatColor(color1)
      let c2 = formatColor(color2)

      const RED = 0.2126;
      const GREEN = 0.7152;
      const BLUE = 0.0722;

      const GAMMA = 2.4;

      const luminance = (r, g, b) => {
        var a = [r, g, b].map((v) => {
          v /= 255;
          return v <= 0.03928
            ? v / 12.92
            : Math.pow((v + 0.055) / 1.055, GAMMA);
        });
        return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
      }

      const contrast = (rgb1, rgb2) => {
        var lum1 = luminance(...rgb1);
        var lum2 = luminance(...rgb2);
        var brightest = Math.max(lum1, lum2);
        var darkest = Math.min(lum1, lum2);
        return (brightest + 0.05) / (darkest + 0.05);
      }
      return contrast(c1, c2)
    }
  },
  computed: {
    ...mapGetters(["user", "subscriptionPackage", "isTrialActive"])
  },
  watch: {
    'menu2': function(newValue, oldValue) {
      if (!newValue && oldValue && this.$v.editBrandingData.primary_color.$invalid) {
        this.editBrandingData.primary_color = this.startingEditPrimaryColor
      }
    }
  }
}
</script>
